import t from 'react-translate';

import { css } from '@emotion/react';
import { primary, white, danger } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';
import { textMediumFontSize } from 'styles/global_defaults/fonts';
import { darkGray } from 'athena/styles/colors';

import NvTimezoneSelector from 'shared/components/nv-timezone-selector';

import { useSelector } from 'react-redux';
import { getUserTimezone } from 'redux/selectors/users';
import { useEffect } from 'react';

const styles = css`
  .input-label {
    color: ${darkGray};
    font-size: ${textMediumFontSize}px;
  }
  &.required {
    .input-label::after {
      content: '*';
      color: ${danger};
    }
  }
  .timezone-input {
    background-color: ${white};
    border-radius: ${quarterSpacing}px;
    &:focus-within {
      border-color: ${primary} !important;
    }
    .icon {
      transform: scale(0.75);
    }
  }
  .timezone-menu {
    max-height: 480px;
    overflow-y: auto;
  }
`;

type TimezoneQuestionProps = {
  title: string;
  answer: string;
  isRequired?: boolean;
  dataQa?: string;
  dataQaId?: string;
  onChange: (
    value: any,
    shouldDirty?: boolean,
    shouldTouch?: boolean,
  ) => void;
};

const TimezoneQuestion = ({
  title,
  answer,
  isRequired,
  dataQa,
  dataQaId,
  onChange,
}: TimezoneQuestionProps) => {
  const currentUserTimezone = useSelector(getUserTimezone);

  useEffect(() => {
    if (!answer) {
      setTimeout(() => {
        onChange(currentUserTimezone, true, false);
      });
    }
  }, [answer, currentUserTimezone]);

  return (
    <div
      css={styles}
      className={isRequired ? 'required' : ''}
      data-qa={dataQa}
      data-qa-id={dataQaId}
    >
      <div className='input-label text-regular semi-bold mb-1'>
        {title}
      </div>
      <NvTimezoneSelector
        className='w-100 timezone-input'
        menuClassName='w-100 timezone-menu'
        defaultTimezone={answer || currentUserTimezone}
        onchange={onChange}
      />
      <div className='text-small semi-bold gray-2'>
        {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.GET_STARTED.PROFILE_MODAL.ORG_QUESTIONS.TIME_ZONE_QUESTION.NOTE()}
      </div>
    </div>
  );
};

export default TimezoneQuestion;
